import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Link } from "react-router-dom";
import ProductsListImage from "./ProductsListImage";
import ProductsListDesc from "./ProductsListDesc";
import styled from "styled-components";
import truncateText from "../../../utils/truncateText";
import ImageWithSkeleton from "../../App/ImageWithSkeleton/ImageWithSkeleton";
import ImageWithSkeletonRegular from "../../App/ImageWithSkeleton copy/ImageWithSkeleton";

const ProductListDetails = (props) => {
  const { listItems = [] } = props;

  const ProductItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0.5rem;
  width: 100%;
  flex: 1;
   margin: unset;
  

  @media (max-width: 600px) {
    width: 95;
    margin: unset;
    
  }
  
  `
  const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .product-title-productview{
  font-size: 0.9rem;
  font-weight: 400;
  color: #555;
  line-height: 1.2;
  text-align: left;
  width: 100%;

  }

  `
  const ProductDetailsPrice = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  p {
  margin: 0;
  font-size: .9rem;
  text-align: left;
  }

  p:first-child {
  color:rgb(3, 174, 34);
  font-weight: 600;
  margin-right: 0.5rem;
  }
  p:last-child {
  text-decoration: line-through;
  color: #999;
  font-weight: 400;
  }   
  
  `

  return (
    <React.Fragment>
      {listItems?.length > 0 &&
        listItems?.map((element) => (
          <ProductItemContainer key={element?.pdUrl}>
            <Link to={element?.pdUrl || "#"} className="route-link">
             {/*  <ProductsListImage imgsrc={element?.imageUrl?.imageUrl} /> */}
             <ImageWithSkeletonRegular src={element?.imageUrl?.imageUrl} alt={element.name}  />

              <ProductDetails>

                <div className="product-title-productview">
                {truncateText(element.name, 30)}
                </div>
                <ProductDetailsPrice>
                  <p>₹ {element.price.discountedPrice}</p> <p>₹ {element.price.price}</p>
                </ProductDetailsPrice>


              </ProductDetails>
              
            </Link>
          </ProductItemContainer>
        ))}
    </React.Fragment>
  );
};
export default ProductListDetails;
